import { API_URL } from 'constants';

export const DEFAULT_ASSIGNEE_INVENTORY_URL = `${API_URL}/api/v1/inventoryItem/assign`;
export const UNASSIGN_ASSIGNEE_INVENTORY_URL = `${API_URL}/api/v1/inventoryItem/unassign`;
